/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as MetadataDistributionPolicy from "./distributionPolicy.defs.js";
import * as MetadataContentWarnings from "./contentWarnings.defs.js";
import * as MetadataContentRights from "./contentRights.defs.js";

const $nsid = "place.stream.metadata.configuration";

export { $nsid };

/** Default metadata record for livestream including content warnings, rights, and distribution policy */
type Main = { $type: "place.stream.metadata.configuration";"contentWarnings"?:MetadataContentWarnings.Main;"contentRights"?:MetadataContentRights.Main;"distributionPolicy"?:MetadataDistributionPolicy.Main };

export type { Main };

/** Default metadata record for livestream including content warnings, rights, and distribution policy */
const main = /*#__PURE__*/ l.record<"literal:self", Main>("literal:self", $nsid, /*#__PURE__*/ l.object({"contentWarnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentWarnings.Main>((() => MetadataContentWarnings.main) as any)),"contentRights":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentRights.Main>((() => MetadataContentRights.main) as any)),"distributionPolicy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataDistributionPolicy.Main>((() => MetadataDistributionPolicy.main) as any))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
